import { render, staticRenderFns } from "./service.vue?vue&type=template&id=af4c34e2&scoped=true"
import script from "./service.vue?vue&type=script&lang=ts"
export * from "./service.vue?vue&type=script&lang=ts"
import style0 from "./service.vue?vue&type=style&index=0&id=af4c34e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4c34e2",
  null
  
)

export default component.exports